import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { apiService } from '../../services/api';
import { courseUrl } from '../../utils/catalogUrls';
import CatalogoNaoEncontrado from './CatalogoNaoEncontrado';

// Navegação interna para /curso/:id (links antigos): o servidor responde 301,
// e no SPA trocamos a URL pela versão com slug sem criar entrada no histórico.
const LegacyCursoRedirect = () => {
  const { id } = useParams();
  const [target, setTarget] = useState(null);

  useEffect(() => {
    let active = true;
    setTarget(null);
    apiService.cursos.get(id)
      .then((response) => {
        if (active) setTarget(response.data?.slug ? courseUrl(response.data) : 'not_found');
      })
      .catch(() => {
        if (active) setTarget('not_found');
      });

    return () => {
      active = false;
    };
  }, [id]);

  if (target === 'not_found') return <CatalogoNaoEncontrado />;
  if (target) return <Navigate to={target} replace />;

  return <div className="seo-page">Carregando...</div>;
};

export default LegacyCursoRedirect;
